import { INDEX_BY_ORDER_TAB } from '@src/orders/domain/OrderTab';
import { DEFAULT_PAGE_SIZE } from '@src/orders/hooks/useCurrentPage';
import { useGetOrderPagination } from '@src/orders/hooks/useGetOrderPagination';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import { useNavigate } from 'react-router-dom';

export const useNavigateToOrderDetails = () => {
  const navigate = useNavigate();

  const { getOrderPagination } = useGetOrderPagination();

  const navigateToOrderDetails = async ({ orderId }: { orderId: string }) => {
    const data = await getOrderPagination({
      assignedToMe: false,
      orderId,
      pageSize: DEFAULT_PAGE_SIZE,
    });

    navigate(
      OrdersNavigation.orderDetail.url({
        orderId,
        page: data.page,
        tabIndex: INDEX_BY_ORDER_TAB[data.tab],
      }),
    );
  };

  return {
    navigateToOrderDetails,
  };
};
